<template>
  <div v-if="authError" class="authenticate-error">
    <p>rmCloud couldn't sign you in.</p>
    <p class="authenticate-error-detail">Please reload the page. If this keeps happening, contact support and quote: {{ authError }}</p>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        authError: null
      }
    },
    created () {
      let location = 'requirements'
      let product = 'jira'
      if (this.$route.params.location === 'configuration') {
        location = 'configuration'
      } else if (this.$route.params.location === 'issue-view-requirements-right-panel') {
        location = 'issueViewRequirementsRightPanel'
      } else if (this.$route.params.location === 'confluence-linked-requirements-macro-editor') {
        location = 'confluenceLinkedRequirementsMacroEditor'
        product = 'confluence'
      } else if (this.$route.params.location === 'confluence-linked-requirements-macro') {
        location = 'confluenceLinkedRequirementsMacro'
        product = 'confluence'
      } else if (this.$route.params.location === 'confluence-insert-requirements-macro-editor') {
        location = 'confluenceInsertRequirementsMacroEditor'
        product = 'confluence'
      } else if (this.$route.params.location === 'confluence-insert-requirements-macro') {
        location = 'confluenceInsertRequirementsMacro'
        product = 'confluence'
      } else if (this.$route.params.location === 'getting-started') {
        location = 'gettingStarted'
      } else if (this.$route.params.location === 'link-requirements-dialog') {
        location = 'linkRequirementsDialog'
      }
      if (product === 'jira') {
        window.AP.sizeToParent()
      }
      const loginObj = {
        data: {
          fullPath: this.$route.fullPath,
          method: 'GET',
          product: product
        },
        success: () => {
          if (location === 'requirements') {
            let currentState = window.AP.history.getState()
            if (currentState) {
              this.setStateFromStateString(currentState)
            } else if (this.$route.query.projectId && this.$route.query.requirementId) {
              window.AP.history.pushState(`${this.$route.query.projectId}-requirements-${this.$route.query.requirementId}`)
              this.setStateFromStateString(`${this.$route.query.projectId}-requirements-${this.$route.query.requirementId}`)
            } else if (this.$route.query.projectId) {
              window.AP.history.pushState(`${this.$route.query.projectId}-requirements`)
              this.setStateFromStateString(`${this.$route.query.projectId}-requirements`)
            } else {
              window.AP.history.pushState('-requirements')
            }
            this.$store.dispatch('refreshProjects')
            this.createHistoryListener()
          }
        },
        error: (resp) => {
          // The backend returns this under 'Result'; 'result' is kept for safety.
          const data = (resp.response && resp.response.data) || {}
          const result = data.Result || data.result
          if (result === 'license') {
            this.$ga.event('error', 'missing-license', this.$route.fullPath, 1)
            this.$auth.logout({
              redirect: {name: 'missing-license'}
            })
            return
          }
          // Any other auth failure used to fall through silently, leaving a
          // blank iframe with no error and nothing reported.
          this.$ga.event('error', 'exchange-token', result || 'unknown', 1)
          this.authError = result || 'unknown'
          this.$auth.logout({redirect: null})
        },
        redirect: {name: location, query: this.$route.query},
        rememberMe: true,
        url: '/api/exchange-token',
        fetchUser: true
      }
      // Only include the redirect part if it's not requirements page, or if it's there's no history state
      if (location === 'requirements') {
        let currentState = window.AP.history.getState()
        if (currentState) {
          loginObj.redirect = null
        }
      }
      this.$auth.login(loginObj)
    },
    methods: {
      setStateFromStateString (stateStr) {
        const itemParams = stateStr.split('-')
        // format: project_id-tab-item_id
        // Set the project
        if (itemParams[0].length > 0) {
          const projectId = Number.parseInt(itemParams[0])
          const currentProject = this.$store.state.currentProject
          if (!currentProject || currentProject.id.toString() !== projectId.toString()) {
            this.$store.dispatch('setCurrentProject', projectId)
          }
        }
        if (itemParams[1] === 'requirements' || itemParams[1] === 'folder') {
          this.$store.commit('setCurrentTab', 'requirements')
          if (itemParams.length === 3) {
            let itemKey = itemParams[1] === 'requirements' ? 'requirement_id' : 'folder_id'
            const item = {
              type: itemParams[1] === 'requirements' ? 'requirement' : 'folder'
            }
            item[itemKey] = Number.parseInt(itemParams[2])
            this.$store.commit('setCurrentItem', item)
          } else {
            this.$store.commit('setCurrentItem', null)
          }
          // Replace doesn't push the item onto the history, because that's being handled by window.AP.history.
          this.$router.replace('/requirements')
        } else if (itemParams[1] === 'traceability') {
          this.$store.commit('setCurrentTab', 'traceability')
          this.$router.replace('/traceability-matrix')
        } else if (itemParams[1] === 'baselines') {
          this.$store.commit('setCurrentTab', 'baselines')
          this.$store.commit('setCurrentBaselinePage', 'baseline-explorer')
          // const baselineParams = e.newURL.split('-')
          if (itemParams.length === 3) {
            const baseline = {
              baseline_id: Number.parseInt(itemParams[2])
            }
            this.$store.commit('setCurrentBaseline', baseline)
          } else {
            this.$store.commit('setCurrentBaseline', null)
          }
          this.$router.replace('/baselines')
        } else if (itemParams[1] === 'comparison') {
          this.$store.commit('setCurrentTab', 'baselines')
          this.$router.replace('/baselines')
          this.$store.commit('setCurrentBaselinePage', 'baseline-comparison')
        }
      },
      createHistoryListener () {
        window.AP.history.popState(e => {
          if (e.newURL) {
            this.setStateFromStateString(e.newURL)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AuthenticateView.vue?74fc0743